import axios from "axios";
import { HttpStatusCodes } from "./types/api/responseCodes";
import { eventEmitter } from "./helpers/eventEmitter";

declare module "axios" {
  interface AxiosRequestConfig {
    skipErrorHandling?: boolean;
    metadata?: {
      addCountry?: boolean;
    };
  }
}
export const mainAPI = axios.create({
  baseURL: process.env.REACT_APP_API_MAIN_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Для автоматического добавления токена
mainAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("xAuthToken");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

mainAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config?.skipErrorHandling) {
      return Promise.reject(error);
    }

    return parseErrorCode(error);
  }
);

mainAPI.interceptors.request.use((config) => {
  // По умолчанию добавляем country_id, если не указано иначе
  const shouldAddCountry = config.metadata?.addCountry !== false;
  if (!shouldAddCountry) {
    return config;
  }
  const countryData = localStorage.getItem("xCountry");
  const country = countryData ? JSON.parse(countryData) : null;

  if (country) {
    if (config.method === "post" || config.method === "put") {
      config.data = {
        ...config.data,
        country_id: country.id,
      };
    } else {
      config.params = {
        ...config.params,
        country_id: country.id,
      };
    }
  }
  return config;
});

const parseErrorCode = (error: any) => {
  if (error.response) {
    const code = error.response.status;
    const textLength = 200;
    let message = "Неизвестная ошибка";
    switch (code) {
      case HttpStatusCodes.UNAUTHORIZED:
        if (window.location.pathname !== "/sign_in/login_password") {
          window.location.replace("/sign_in/refresh_token");
          break;
        }

        message =
          error.response.data.detail ||
          error.response.data ||
          error.response ||
          "Ошибка авторизации";
        break;
      case HttpStatusCodes.FORBIDDEN:
        message =
          error.response.data.detail ||
          error.response.data ||
          error.response ||
          "Доступ запрещен";
        break;
      case HttpStatusCodes.BAD_REQUEST:
        message =
          error.response.data.detail ||
          error.response.data ||
          error.response ||
          "Ошибка в запросе";
        break;
      default:
        message =
          error.response.data.detail ||
          error.response.data ||
          error.response ||
          "Неизвестная ошибка";
        console.warn(error.response);
    }

    if (error.response.data instanceof Blob) {
      message = `Ошибка ${code}`;
    }

    eventEmitter.emit("alert", {
      message: message.slice(0, textLength),
      title: "Error",
      variant: "critical",
    });
  }

  return Promise.reject(error.response);
};

export function handleApiError(
  error: any,
  defaultMessage: string = "Произошла ошибка"
) {
  const apiError = error.response?.data || error.data?.detail;
  return Promise.reject(
    new Error(apiError?.detail || apiError || defaultMessage)
  );
}
